import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  addLeaveType,
  clearError,
  clearSuccess,
} from "../../../../redux/Slices/authSlice";
import { FaArrowLeft, FaPlus } from "react-icons/fa";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const AddVacation = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation("global");
  const isRTL = i18n.language === "ar";
  const { isLoading, error, success } = useSelector(state => state.auth);
  const [formData, setFormData] = useState({
    name_en: "",
    name_ar: "",
    default_balance: "",
    is_active: false,
  });
  const textAlign = isRTL ? "right" : "left";
  const dir = isRTL ? "rtl" : "ltr";
  const lastErrorRef = useRef({ message: null, time: 0 });

  useEffect(() => {
    if (success) {
      toast.success(success, { rtl: isRTL });
      dispatch(clearSuccess());
      setTimeout(() => {
        navigate("/vacations");
      }, 1000);
    }
    if (error) {
      const now = Date.now();
      const last = lastErrorRef.current;
      if (!last.message || last.message !== error || now - last.time > 2000) {
        toast.error(error, { rtl: isRTL });
        lastErrorRef.current = { message: error, time: now };
      }
      setTimeout(() => dispatch(clearError()), 3000);
    }
  }, [success, error, navigate, dispatch, isRTL]);

  const handleInputChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: name === "is_active" ? value === "true" : value,
    }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!formData.name_en || !formData.name_ar || !formData.default_balance) {
      toast.error(t("vacations.add.validation.requiredFields"), { rtl: isRTL });
      return;
    }

    const submitData = {
      ...formData,
      default_balance: parseInt(formData.default_balance),
    };

    await dispatch(addLeaveType(submitData));
  };

  const handleCancel = () => {
    navigate("/vacations");
  };

  return (
    <div
      style={{
        padding: "30px",
        backgroundColor: "#14263b",
        minHeight: "calc(100vh - 80px)",
        color: "white",
        direction: dir,
      }}
    >
      <div style={{ marginBottom: "30px" }}>
        <button
          onClick={() => navigate("/vacations")}
          style={{
            backgroundColor: "#666",
            color: "white",
            border: "none",
            padding: "10px",
            borderRadius: "8px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginBottom: "20px",
            fontSize: "14px",
            flexDirection: isRTL ? "row" : "row-reverse",
          }}
        >
          <FaArrowLeft />
          {t("vacations.add.back")}
        </button>

        <h1
          style={{
            fontSize: "24px",
            fontWeight: "bold",
            color: "white",
            margin: 0,
            textAlign,
          }}
        >
          {t("vacations.add.title")}
        </h1>
      </div>

      <div
        style={{
          backgroundColor: "#1b3350",
          borderRadius: "12px",
          padding: "30px",
          border: "1px solid #333",
        }}
      >
        <form onSubmit={handleSubmit}>
          <div style={{ display: "flex", gap: "30px", flexWrap: "wrap" }}>
            <div style={{ flex: "1", minWidth: "300px" }}>
              {/* الاسم بالعربية */}
              <div style={{ marginBottom: "20px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    color: "white",
                    fontWeight: "500",
                    textAlign,
                  }}
                >
                  {t("vacations.add.fields.nameAr")}
                </label>
                <input
                  type="text"
                  name="name_ar"
                  value={formData.name_ar}
                  onChange={handleInputChange}
                  placeholder={t("vacations.add.placeholders.nameAr")}
                  required
                  style={{
                    width: "100%",
                    padding: "12px 15px",
                    backgroundColor: "#1a1f2e",
                    border: "1px solid #333",
                    borderRadius: "8px",
                    color: "white",
                    fontSize: "14px",
                    textAlign,
                    direction: dir,
                  }}
                />
              </div>

              <div style={{ marginBottom: "20px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    color: "white",
                    fontWeight: "500",
                    textAlign,
                  }}
                >
                  {t("vacations.add.fields.nameEn")}
                </label>
                <input
                  type="text"
                  name="name_en"
                  value={formData.name_en}
                  onChange={handleInputChange}
                  placeholder={t("vacations.add.placeholders.nameEn")}
                  required
                  style={{
                    width: "100%",
                    padding: "12px 15px",
                    backgroundColor: "#1a1f2e",
                    border: "1px solid #333",
                    borderRadius: "8px",
                    color: "white",
                    fontSize: "14px",
                    textAlign,
                    direction: dir,
                  }}
                />
              </div>
            </div>

            {/* العمود الأيمن */}
            <div style={{ flex: "1", minWidth: "300px" }}>
              {/* الرصيد الافتراضي */}
              <div style={{ marginBottom: "20px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    color: "white",
                    fontWeight: "500",
                    textAlign,
                  }}
                >
                  {t("vacations.add.fields.defaultBalance")}
                </label>
                <input
                  type="number"
                  name="default_balance"
                  value={formData.default_balance}
                  onChange={handleInputChange}
                  placeholder={t("vacations.add.placeholders.defaultBalance")}
                  required
                  min="0"
                  style={{
                    width: "100%",
                    padding: "12px 15px",
                    backgroundColor: "#1a1f2e",
                    border: "1px solid #333",
                    borderRadius: "8px",
                    color: "white",
                    fontSize: "14px",
                    textAlign,
                    direction: dir,
                  }}
                />
              </div>

              {/* is_active dropdown */}
              <div style={{ marginBottom: "20px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    color: "white",
                    fontWeight: "500",
                    textAlign,
                  }}
                >
                  {t("vacations.add.fields.isActive")}
                </label>
                <select
                  name="is_active"
                  value={formData.is_active ? "true" : "false"}
                  onChange={handleInputChange}
                  required
                  style={{
                    width: "100%",
                    padding: "12px 15px",
                    backgroundColor: "#1a1f2e",
                    border: "1px solid #333",
                    borderRadius: "8px",
                    color: "white",
                    fontSize: "14px",
                    textAlign,
                    direction: dir,
                    cursor: "pointer",
                  }}
                >
                  <option value="false">
                    {t("vacations.add.fields.inactive")}
                  </option>
                  <option value="true">
                    {t("vacations.add.fields.active")}
                  </option>
                </select>
              </div>
            </div>
          </div>

          {/* أزرار الإجراء */}
          <div
            style={{
              display: "flex",
              gap: "15px",
              marginTop: "30px",
              justifyContent: "center",
              flexDirection: isRTL ? "row" : "row-reverse",
            }}
          >
            <button
              type="submit"
              disabled={isLoading}
              style={{
                backgroundColor: isLoading ? "#666" : "#AC2000",
                color: "white",
                border: "none",
                padding: "12px 30px",
                borderRadius: "8px",
                fontSize: "16px",
                fontWeight: "bold",
                cursor: isLoading ? "not-allowed" : "pointer",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                opacity: isLoading ? 0.6 : 1,
                flexDirection: isRTL ? "row" : "row-reverse",
              }}
            >
              {isLoading ? (
                <>
                  <div
                    style={{
                      width: "16px",
                      height: "16px",
                      border: "2px solid white",
                      borderTop: "2px solid transparent",
                      borderRadius: "50%",
                      animation: "spin 1s linear infinite",
                    }}
                  />
                  {t("vacations.add.buttons.adding")}
                </>
              ) : (
                <>
                  <FaPlus />
                  {t("vacations.add.buttons.add")}
                </>
              )}
            </button>

            <button
              type="button"
              onClick={handleCancel}
              style={{
                backgroundColor: "#666",
                color: "white",
                border: "none",
                padding: "12px 30px",
                borderRadius: "8px",
                fontSize: "16px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              {t("vacations.add.buttons.cancel")}
            </button>
          </div>
        </form>
      </div>

      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default AddVacation;
